import { Link } from 'react-router-dom';
import { StoryCard as Card } from '../../types/commerce';
export default function StoryCard({ story }: { story: Card }) {
  return (
    <article className="story-card">
      <Link to={`/stories/${story.slug}`}>
        <img src={story.cover_image_url} alt="" loading="lazy" />
        <h2>{story.title}</h2>
      </Link>
      {story.summary && <p>{story.summary}</p>}
    </article>
  );
}
